module.exports = __webpack_public_path__ + "static/media/mars-stroke-h.80181552.svg";